export const formError = {
  "form_error_required": "This field is required",
  "form_default_error": "Invalid input",
  "form_error_email": "This email is not valid",
  "form_error_email_password": "Password should contains uppercase, lowercase and symbols",
  "form_error_min": "Should be minmum {{min}} charcters long",
  "form_error_email_confirm_password": "Password not identical",
  "form_error_phone": "The phone number is not valid",
  "form_error_email_or_phone_required": "Email or phone number is required",
  "form_error_nir": "This social security number is not valid (check the 15 digits and the control key).",
  "form_error_nir_birthdate_invalid": "This date of birth is not valid.",
  "form_error_nir_birthdate_mismatch": "This date of birth does not match your social security number (birth year and month).",
}